export default function debouncePromise(fn: (...args: unknown[]) => unknown, time: number) {
  let timerId: number | undefined

  return async function debounced(...args: unknown[]) {
    if (timerId) {
      clearTimeout(timerId)
    }

    return new Promise(resolve => {
      timerId = window.setTimeout(() => {
        resolve(fn(...args))
      }, time)
    })
  }
}
